/**
 * 字典
 * @author francklin
 * @created 2021.06.02
 */
import _ from 'lodash'

const self = {
  state: {
    hash: {}
  },
  getters: {
    getDictText: (state) => (key,itemValue) => {
      var obj=state,keys=key.split(".");
      for(let i=0;i<keys.length-1;i++){
        obj=obj[keys[i]];
      }
      var data=obj[keys.pop()];
      for(let i=0;i<data.length;i++){
        if(_.isArray(data[i])){
          if(data[i][1]==itemValue) {
            return data[i][0]||"";
          }
        } else {
          if(data[i].value==itemValue) {
            return data[i].text||"";
          }
        }
      }
      return "";
    },
    getDictItem: (state) => (key,itemValue) => {
      var obj=state,keys=key.split(".");
      for(let i=0;i<keys.length-1;i++){
        obj=obj[keys[i]];
      }
      var data=obj[keys.pop()];
      for(let i=0;i<data.length;i++){
        if(_.isArray(data[i])){
          if(data[i][1]==itemValue) {
            return data[i];
          }
        } else {
          if(data[i].value==itemValue) {
            return data[i];
          }
        }
      }
      return "";
    }
  },
  mutations: {
    SET_DICT (state, {key,value}) {
      var obj=state,keys=key.split(".");
      for(let i=0;i<keys.length-1;i++){
        obj=obj[keys[i]];
      }
      obj[keys.pop()]=value;
    },
    //type: 0, by value; 1, by text
    HASH_DICT (state, {key,type}) {
      var obj=state,keys=key.split(".");
      var hash=state.hash;
      for(let i=0;i<keys.length;i++){
        obj=obj[keys[i]];
        if(i>0&&hash[keys[i]]) hash=hash[keys[i]];
        else if(i>0) hash[keys[i]]=hash={};
      }
      for(let i=0,data=obj;i<data.length;i++){
        if(type==0){
          if(_.isArray(data[i])){
            if(data[i][1]) hash[data[i][1]]=data[i][0];
          } else {
            if(data[i].text) hash[data[i].value]=data[i].text;
          }
        } else if(type==1){
          if(_.isArray(data[i])){
            if(data[i][0]) hash[data[i][0]]=data[i][1];
          } else {
            if(data[i].text) hash[data[i].text]=data[i].value;
          }
        }
      }
    }
  }
}

export default self
